<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useColorModes } from '@coreui/vue-pro'
import { useThemeStore } from '@/store/theme.ts'
import '@coreui/coreui-pro/dist/css/coreui.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'

 
const { isColorModeSet, setColorMode } = useColorModes(
  'coreui-free-vue-admin-template-theme',
)

const currentTheme = useThemeStore()


onBeforeMount(() => {
  const urlParams = new URLSearchParams(window.location.href.split('?')[1])
  let theme = urlParams.get('theme')

  if (theme !== null && theme.match(/^[A-Za-z0-9\s]+/)) {
    theme = theme.match(/^[A-Za-z0-9\s]+/)[0]
  }

  if (theme) {
    setColorMode(theme)
    return
  }

  if (isColorModeSet()) {
    return
  }

  setColorMode(currentTheme.theme)
}) 
</script>

<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'App',
})
</script>

<style lang="scss">
@use '@/styles/style';
</style>